import axios from "axios";
import apiConfig from "@/utils/apiConfig";

function uuid() {
    var d = Date.now();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

function axiosGet(API, DATA, successCallback, failCallback) {
    axios({
        withCredentials: true,
        url: API,
        method: 'GET',
        data: DATA || {} // 需加上空data否則 headers不會動作
    })
        .then((res) => {
            if (successCallback) {
                successCallback(res.data);
            }
        })
        .catch((e) => {
            if (failCallback) {
                failCallback(e);
            }
        })
}

function axiosPost(API, DATA, successCallback, failCallback, tokenInfo) {
    let cusHeader = {};
    cusHeader['Content-Type'] = 'application/json';
    if (tokenInfo) {
        cusHeader[tokenInfo.header] = tokenInfo.token;
    }

    axios({
        withCredentials: true,
        url: API,
        method: 'POST',
        headers: cusHeader,
        data: DATA || {} // 需加上空data否則 headers不會動作
    })
        .then((res) => {
            if (successCallback) {
                successCallback(res.data);
            }
        })
        .catch((e) => {
            if (failCallback) {
                failCallback(e);
            }
        })
}

const UserStatus = {
    // 註冊 OTP
    otpRegister(registerData, whenOtpSuccess, whenOtpFail, whenSysFail) {
        let API = apiConfig.memberDomain + apiConfig.otpRegister;
        axiosPost(
            API,
            registerData,
            (res) => {
                if (res.code == 200) {
                    // OTP 發送成功
                    if (whenOtpSuccess) {
                        whenOtpSuccess('register', res);
                    }
                } else {
                    // OTP 發送異常
                    if (whenOtpFail) {
                        whenOtpFail(res);
                    }
                }
            },
            whenSysFail);
    },

    // 驗證註冊 OTP
    checkOtpRegister(registerData, whenOtpSuccess, whenOtpFail, whenSysFail) {

        registerData.appId = apiConfig.APP_ID;

        let API = apiConfig.memberDomain + apiConfig.checkOtpRegister;
        axiosPost(
            API,
            registerData,
            (res) => {
                if (res.code == 200) {
                    let jwtInfo = res.data;
                    // OTP 驗證成功
                    if (whenOtpSuccess) {
                        whenOtpSuccess(jwtInfo);
                    }
                } else {
                    // OTP 驗證失敗
                    if (whenOtpFail) {
                        whenOtpFail(res);
                    }
                }
            },
            whenSysFail);

    },

    // 登入 OTP
    otpLogin(logData, whenOtpSuccess, whenOtpFail, whenSysFail) {
        let API = apiConfig.memberDomain + apiConfig.otpLogin;
        axiosPost(
            API,
            logData,
            (res) => {
                if (res.code == 200) {
                    // OTP 發送成功
                    if (whenOtpSuccess) {
                        whenOtpSuccess('login', res);
                    }
                } else {
                    // OTP 發送異常
                    if (whenOtpFail) {
                        whenOtpFail(res);
                    }
                }
            },
            whenSysFail);
    },

    // 驗證登入 OTP
    checkOtpLogin(otpInfo, whenOtpSuccess, whenOtpFail, whenSysFail) {

        otpInfo.appId = apiConfig.APP_ID;

        let API = apiConfig.memberDomain + apiConfig.checkOtpLogin;
        axiosPost(
            API,
            otpInfo,
            (res) => {
                if (res.code == 200) {
                    let jwtInfo = res.data;
                    // OTP 驗證成功
                    if (whenOtpSuccess) {
                        whenOtpSuccess(jwtInfo);
                    }
                } else if (res.code == 400) {
                    // OTP 驗證失敗
                    if (whenOtpFail) {
                        whenOtpFail(res);
                    }
                } else {
                    // OTP 驗證失敗
                    if (whenOtpFail) {
                        whenOtpFail(res);
                    }
                }
            },
            whenSysFail);
    },

    // 更換 JWT
    refreshToken(appKey, callback) {
        let API = apiConfig.memberDomain + apiConfig.refreshToken + '?appKey=' + appKey;
        axiosGet(
            API,
            null,
            (res) => {
                if (res.code == 200) {
                    let jwtInfo = res.data;
                    localStorage.setItem('jwtInfo', JSON.stringify(jwtInfo));
                    if (callback) {
                        callback(jwtInfo);
                    }
                } else {
                    localStorage.removeItem('jwtInfo');
                    if (callback) {
                        callback();
                    }
                }
            });
    },

    // 更換 JWT (限開發使用)
    refreshTokenForDev(data, callback) {
        let API = apiConfig.memberDomain + '/member/v4/refreshToken4Dev';
        axiosPost(
            API,
            data,
            (res) => {
                if (res.code == 200) {
                    let jwtInfo = res.data;
                    localStorage.setItem('jwtInfo', JSON.stringify(jwtInfo));
                    if (callback) {
                        callback(jwtInfo);
                    }
                } else {
                    localStorage.removeItem('jwtInfo');
                    if (callback) {
                        callback();
                    }

                }
            });
    },

    // 登出
    logout(appKey, callback) {
        let removeStorage = ['jwtInfo','detailStorage','pageStorage','applicationNo','insTraOrderId','confirmPolicyType','confirmStorage','otp','fromPage','uploadStorage','registerStorage','logData'];
        removeStorage.forEach(k =>
            sessionStorage.removeItem(k)
        )
        removeStorage.forEach(k =>
            localStorage.removeItem(k)
        )

        let attachAppKey = (appKey) ? ('?appKey=' + appKey) : '';
        let API = apiConfig.memberDomain + apiConfig.logout + attachAppKey;
        axiosGet(
            API,
            null,
            callback,
            callback);
    },

    // 判斷系統是否超載
    isOverflow(whenSuccess, whenFail) {
        let API = apiConfig.memberDomain + apiConfig.isOverflow + '?token=' + uuid();
        axiosGet(
            API,
            null,
            (res) => {
                if (whenSuccess) {
                    whenSuccess(res);
                }
            },
            (e) => {
                if (whenFail) {
                    whenFail(e);
                }
            });
    }
}

export default UserStatus;